
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-banking",
      function () {
        return require("private-next-pages/open-banking.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-banking"])
      });
    }
  